import { updateItems } from "@/mocks/homeData";

const typeStyles: Record<string, string> = {
  "上架": "bg-green-100 text-green-700",
  "里程碑": "bg-accent-100 text-accent-700",
  "更新": "bg-primary-100 text-primary-700",
  "专题": "bg-secondary-100 text-secondary-700",
  "基建": "bg-amber-100 text-amber-700",
  "合作": "bg-rose-100 text-rose-700",
  "安全": "bg-emerald-100 text-emerald-700",
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            黄桃视频平台最新进展与内容更新速览
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updateItems.map((item, i) => (
            <div
              key={item.id}
              className="flex items-start gap-4 pb-5 mb-5 border-b border-background-200/50 last:border-0"
            >
              <div className="flex flex-col items-center flex-shrink-0">
                <div className="w-2.5 h-2.5 rounded-full bg-primary-500 mt-1.5"></div>
                {i < updateItems.length - 1 && (
                  <div className="w-px h-full bg-background-300 mt-1.5"></div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className="text-[11px] text-foreground-400 font-label">{item.date}</span>
                  <span className={`px-2 py-0.5 rounded text-[10px] font-semibold font-label ${typeStyles[item.type] || "bg-foreground-100 text-foreground-600"}`}>
                    {item.type}
                  </span>
                </div>
                <p className="text-sm text-foreground-800 leading-relaxed">
                  {item.title}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}